import { render, staticRenderFns } from "./patch-content.vue?vue&type=template&id=ceea013a&scoped=true"
import script from "./patch-content.vue?vue&type=script&lang=js"
export * from "./patch-content.vue?vue&type=script&lang=js"
import style0 from "./patch-content.vue?vue&type=style&index=0&id=ceea013a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceea013a",
  null
  
)

export default component.exports